import axios from "@/lib/axios";
import { DimensionId, DimensionsSummary } from "@/types/questionnaries";

export type DimensionByQuizIdRequestParams = {
  companyId: string;
  applicationQuizId: string;
  dimension: DimensionId | string;
};

export type DimensionByQuizIdResponse = DimensionsSummary;

export const dimensionByQuizId = async (
  params: DimensionByQuizIdRequestParams,
) =>
  axios
    .get<DimensionByQuizIdResponse>(
      `/v1/companies/${params.companyId}/application-quizzes/${params.applicationQuizId}/dimensions/${params.dimension}`,
    )
    .then((res) => res.data);
